import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import { grey } from "@mui/material/colors";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import { favoriteChange, getDataJacketImage } from "../../js/queriesHandling";
import { CssDataJacketBodyChip } from "../../styles/styled";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { CssDataJacketBodyTypography } from "../../styles/styled";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#505458",
      sub: grey[50],
      light: grey[50],
      dark: grey[900],
      constrastText: grey[50],
    },
    secondary: {
      main: "#75787b",
    },
  },
});

const DataJacketCard = styled(Card)`
  ${({ theme }) => `
  cursor: pointer;
  text-align: 'left';
  border-radius: '10px';
  background-color: ${theme.palette.primary.main};
  transition: ${theme.transitions.create(["background-color", "transform"], {
    duration: theme.transitions.duration.standard,
  })};
  &:hover {
    background-color: ${theme.palette.secondary.main};
    transform: scale(1.03);
    border-color: 'white';
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  `}
`;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 220,
  },
}));

export const DataJacketCardComponent = React.forwardRef(
  function DataJacketCardComponent(
    { dataJacket, jacketId, info, user },

    ref
  ) {
    const [image, setImage] = React.useState("");
    const [bookmarked, setBookmarked] = React.useState(
      dataJacket.user_favorite_flag
    );
    let onProcessBookmark = false;
    const navigate = useNavigate();

    function _navigateToPage(passId, info, user, e) {
      if (onProcessBookmark) {
        onProcessBookmark = false;
        return;
      }
      if (e && (e.ctrlKey || e.metaKey)) {
        const url = "#/dataJacket";
        const id = passId;
        localStorage.setItem("id", id);

        // aタグを使って新しいタブで開く
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.click();
      } else {
        const id = passId;
        const userName = user;
        navigate("/dataJacket", {
          state: {
            id,
            userName,
          },
        });
      }
    }

    async function getImage(id) {
      var strImage = await getDataJacketImage(id);
      setImage({ data: strImage.replace(/\"/g, "") });
    }
    function industryChip() {
      let result = [];
      let tooltip = [];
      dataJacket.data_jacket_industry.split(",").map((industry, index) => {
        if (industry !== "" && industry !== undefined) {
          if (index < 6) {
            result.push(
              <CssDataJacketBodyChip
                style={{
                  marginTop: "0",
                  marginRight: "0",
                  padding: "-4px -4px -4px -4px",
                  backgroundColor: "#75787B",
                  marginBottom: "4px",
                }}
                label={industry}
              />
            );
          } else {
            tooltip.push(
              <CssDataJacketBodyTypography style={{ color: "black" }}>
                {industry}
              </CssDataJacketBodyTypography>
            );
          }
        }
      });
      if (tooltip.length > 0) {
        result.push(
          <HtmlTooltip title={tooltip}>
            <CssDataJacketBodyChip
              style={{
                marginTop: "0",
                marginRight: "0",
                padding: "-4px -4px -4px -4px",
                backgroundColor: "#75787B",
              }}
              label={"..."}
            />
          </HtmlTooltip>
        );
      }
      return result;
    }

    function onClickBookmark() {
      onProcessBookmark = true;
      favoriteChange(
        user,
        dataJacket.data_jacket_id,
        !dataJacket.user_favorite_flag
      )
        .then((evt) => {})
        .catch((err) => {});
      // アイコンを切り替え
      dataJacket.user_favorite_flag = !dataJacket.user_favorite_flag;
      setBookmarked(dataJacket.user_favorite_flag);
    }

    React.useEffect(() => {
      getImage(jacketId);
    }, []);

    return (
      <Grid
        xs={2}
        sm={3}
        md={3}
        onClick={(e) => _navigateToPage(jacketId, info, user, e)}
      >
        <ThemeProvider theme={customTheme}>
          <Fade in={true} timeout={1200}>
            <DataJacketCard
              ref={ref}
              style={{
                border: "none",
                minHeight: "350px",
                display: "flex",
                flexDirection: "column ",
              }}
            >
              <CardContent
                style={{
                  padding: "0",
                  height: "130px",
                }}
              >
                {image.data ? (
                  <img
                    src={`data:image/png;base64,${image.data}`}
                    alt="データジャケット画像"
                    style={{
                      height: "130px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  ""
                )}
              </CardContent>
              <CardContent
                style={{
                  marginLeft: "16px",
                  marginRight: "16px",
                  color: "white",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  {dataJacket.data_jacket_name}
                </Typography>
                {!bookmarked ? (
                  <IconButton onClick={onClickBookmark}>
                    <FavoriteIcon
                      style={{
                        marginTop: "6px",
                        color: "white",
                      }}
                    />
                  </IconButton>
                ) : (
                  <IconButton onClick={onClickBookmark}>
                    <FavoriteBorderIcon
                      style={{
                        marginTop: "6px",
                        color: "white",
                      }}
                    />
                  </IconButton>
                )}
              </CardContent>
              <CardContent
                style={{
                  fontSize: "16px",
                  marginLeft: "12px",
                  marginRight: "12px",
                  color: "white",
                  padding: "8px",
                  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                }}
              >
                {dataJacket.data_jacket_summary}
              </CardContent>
              <CardContent
                style={{
                  fontSize: "16px",
                  marginLeft: "12px",
                  marginRight: "12px",
                  color: "white",
                  padding: "8px",
                  display: "flex",
                  justifyContent: "row",
                }}
              >
                <Box
                  style={{
                    marginTop: "1px",
                  }}
                >
                  <FavoriteIcon
                    style={{
                      marginTop: "6px",
                      color: "white",
                    }}
                  />
                </Box>
                <Typography
                  style={{
                    marginTop: "6px",
                    color: "white",
                    fontSize: "16px",
                    marginLeft: "4px",
                    minWidth: "50px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  {dataJacket.favorite_count}
                </Typography>
              </CardContent>
              <CardContent
                style={{
                  padding: "0",
                  color: "white",
                  marginLeft: "18px",
                  display: "flex",
                  marginBottom: "2px",
                  marginRight: "18px",
                }}
              >
                <LocalOfferIcon
                  style={{
                    marginTop: "6px",
                    color: "white",
                    marginRight: "4px",
                  }}
                />
                <Box
                  style={{
                    marginTop: "1px",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  {industryChip()}
                </Box>
              </CardContent>
              <CardContent
                style={{
                  padding: "0",
                  color: "white",
                  marginLeft: "18px",
                  marginRight: "6px",
                  display: "flex",
                }}
              >
                <PersonOutlineOutlinedIcon
                  style={{ color: "white", marginRight: "8px" }}
                />
                <Box
                  style={{
                    marginTop: "2px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                    fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                  }}
                >
                  {"公開者：" + dataJacket.data_jacket_publisher}
                </Box>
              </CardContent>
            </DataJacketCard>
          </Fade>
        </ThemeProvider>
      </Grid>
    );
  }
);
